// Types
import { User } from 'Shared/constants/types';
import { FactorPiSuggestedTopic, FactorCombinationPiSuggestedTopic } from 'Shared/types/PiSuggestedTopic.type';

// Constants
import {
  GeneralPiSuggestedTopics,
  FactorPiSuggestedTopics,
  FactorCombinationPiSuggestedTopics,
} from 'Shared/constants/PiSuggestedTopics.constants';

// Hooks
import { useBaProfile } from './use-ba-profile';
import { BaPersonInfo } from 'Shared/types/BaInfo.types';

type Props = {
  user: User;
};

export const usePiSuggestedTopics = ({ user }: Props) => {
  const { baProfile } = useBaProfile({ user, withFetch: false });

  const getFactorTopicsForUser = (baProfile: BaPersonInfo): FactorPiSuggestedTopic[] => {
    return baProfile.factors
      .map(factor => {
        let sigmaZonePlacement = 'situational';
        if (factor.sigmaZone > 0) sigmaZonePlacement = 'high';
        else if (factor.sigmaZone < 0) sigmaZonePlacement = 'low';

        return FactorPiSuggestedTopics.filter(
          topic =>
            topic.factor.toUpperCase() === factor.letter.toUpperCase() &&
            topic.sigmaZonePlacement === sigmaZonePlacement
        );
      })
      .flat()
      .map(topic => ({ ...topic, basedOn: topic.basedOn.replace('%first_name%', baProfile.name.first) }));
  };

  const getFactorCombinationTopicsForUser = (baProfile: BaPersonInfo): FactorCombinationPiSuggestedTopic[] => {
    return baProfile.factorCombinations
      .map(combo => {
        return FactorCombinationPiSuggestedTopics.filter(
          topic => topic.combination.toUpperCase() === combo.typeDescription.toUpperCase()
        );
      })
      .flat()
      .map(topic => ({ ...topic, basedOn: topic.basedOn.replace('%first_name%', baProfile.name.first) }));
  };

  const userSuggestedTopics: Array<FactorPiSuggestedTopic | FactorCombinationPiSuggestedTopic> = [
    ...getFactorTopicsForUser(baProfile),
    ...getFactorCombinationTopicsForUser(baProfile),
  ];

  return { generalSuggestedTopics: GeneralPiSuggestedTopics, userSuggestedTopics };
};
